export default __webpack_public_path__ + "static/media/section14 mobile.61b70f08.png";